/* eslint-disable import/no-namespace */
import { URL } from '../../config'
import { getRequest } from '../../utils/functions/httpRequest'
import * as types from './'

// define URLS
const userURL = URL.user

export function checkUserRole(role) {
	return function(getStore)
	{
		const url       = `${userURL}/inrole/${role}`
		const userToken = getStore().oidc.user.access_token
		const request = getRequest(url,'json',userToken)
		return {
			type: types.user.CHECK_USER_ROLE,
			payload: request
		}
	}
}

export function getUserRole() {	
	return (dispatch, getState) =>
	{
		dispatch(checkingUserRole())
		const url       = `${userURL}/userrole`
		const userToken = getState().oidc.user.access_token
		getRequest(url,'json',userToken).then(resp => {
			dispatch(getUserRoleSuccess(resp.data))
		})
	}	
}

export function setUserRole(roleName)
{
	const payload = {
		roleName
	}
	return {
		type: types.user.SET_USER_ROLE,
		payload: payload
	}
}
 
export function  getUserRoleSuccess(userRole) {
	return {
		type:  types.user.GET_USER_ROLE,
		payload: {
			...userRole
		}
	}
}

export function  checkingUserRole() {
	return {
		type:  types.user.CHECKING_USER_ROLE,
	}
}


// WEBPACK FOOTER //
// ./src/redux/actions/action_user.js